import { GoalsMetricTypeEnum } from 'generated/resources/graphql'

type BaseMetric = {
  type: GoalsMetricTypeEnum
  quantitativeValue?: unknown
  qualitativeValue?: unknown
}

export type NormalizedQuantitativeMetric<T extends BaseMetric> = Omit<T, 'qualitativeValue'> & {
  type: 'quantitative'
  quantitativeValue: NonNullable<T['quantitativeValue']>
}

export type NormalizedQualitativeMetric<T extends BaseMetric> = Omit<T, 'quantitativeValue'> & {
  type: 'qualitative'
  qualitativeValue: NonNullable<T['qualitativeValue']>
}

export type NormalizedMetric<T extends BaseMetric> =
  | NormalizedQuantitativeMetric<T>
  | NormalizedQualitativeMetric<T>

function isQuantitative<T extends BaseMetric>(
  metric: T
): metric is T & { quantitativeValue: NonNullable<T['quantitativeValue']> } {
  return metric.type === 'quantitative'
}

function isQualitative<T extends BaseMetric>(
  metric: T
): metric is T & { qualitativeValue: NonNullable<T['quantitativeValue']> } {
  return metric.type === 'qualitative'
}

export const normalizeMetric = <T extends BaseMetric>(
  metric: T
): NormalizedQuantitativeMetric<T> | NormalizedQualitativeMetric<T> => {
  if (isQualitative(metric)) {
    return {
      ...metric,
      type: 'qualitative',
    }
  } else if (isQuantitative(metric)) {
    return {
      ...metric,
      type: 'quantitative',
    }
  } else {
    throw new Error('Invalid metric type')
  }
}
